// src/utils/privilegeUtils.js
export function getUserPrivileges() {
    try {
        return JSON.parse(localStorage.getItem('userPrivileges')) || [];
    } catch {
        return [];
    }
}

export function hasMenuPrivilege(menuName) {
    const privileges = getUserPrivileges();
    return privileges.some(
        (priv) => priv.menu && priv.menu.name === menuName
    );
}

export function isCarrierOrAgentOrg() {
    try {
        const orgTypes = JSON.parse(localStorage.getItem('organizationTypes') || '[]');
        return orgTypes.includes('carrier') || orgTypes.includes('agent');
    } catch {
        return false;
    }
}